module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            card: '='
        },
        require: '?^wowCard',
        link(scope) {
            scope.clickTracker = function () {
                fetch(this.card.ClickTracker);
            };
        },
        template: require('./feature-card-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/feature-card/feature-card-directive.js
 **/